export enum MenuDisplayMode {
  SMALL = 'small',
  DEFAULT = 'default',
}

export enum MenuItemDisplayMode {
  ICON_ONLY = 'icon_only',
  DEFAULT = 'default',
}
